import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import './UserManagement.css';
import CustomTabListView from '../../components/common/CustomTabListView';
import localforage from 'localforage';
import { tabsData } from './TabsData';

const UserTabs = (props: any) => {
  const { tabs = [] } = props;

  useEffect(() => {

    return () => {
      localforage.clear();
    }
  },[]);
  
  return (
    <div className="user-management">
      <CustomTabListView {...props} id={'user-management-tabs'}>
        {tabs.map((list: string) => {
          return (
            <Tab key={list} eventKey={list} title={list}>
              {<div>{tabsData?.[list]}</div>}
            </Tab>
          );
        })}
      </CustomTabListView>
    </div>
  );
};
export default UserTabs;
